import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=cb65bd32&scoped=true&"
import script from "./Form1.vue?vue&type=script&lang=js&"
export * from "./Form1.vue?vue&type=script&lang=js&"
import style0 from "./Form1.vue?vue&type=style&index=0&id=cb65bd32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb65bd32",
  null
  
)

export default component.exports